import { render, staticRenderFns } from "./IbTag.vue?vue&type=template&id=0b0f3981&scoped=true"
import script from "./IbTag.vue?vue&type=script&lang=js"
export * from "./IbTag.vue?vue&type=script&lang=js"
import style0 from "./IbTag.vue?vue&type=style&index=0&id=0b0f3981&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0f3981",
  null
  
)

export default component.exports